module.exports = __webpack_public_path__ + "img/1289459813.87e14e82.jpg";